import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/documents';

// GETBYID
function getById(state, action) {
  state.getById.data = action.payload.data ? action.payload.data:[];
}

function conexionGetById(state, action) {
  state.getById.connection= action.payload.connection;
}

function errorGetById(state, action) {
  state.getById.error= action.payload.error ? action.payload.error:false;
  state.getById.message= action.payload.message ? action.payload.message:"";
}

// CREATE
function create(state, action) {
  state.create.result = action.payload.result ? action.payload.result:false;
}

function conexionCreate(state, action) {
  state.create.connection= action.payload.connection;
}

function errorCreate(state, action) {
  state.create.error= action.payload.error ? action.payload.error:false;
  state.create.message= action.payload.message ? action.payload.message:"";
}

function createReset(state, action) {
  state.create.result=false;
  state.create.connection= false;
  state.create.error= false;
  state.create.message= "";
}

// GETBYIDDONWLOAD
function getByIdDonwload(state, action) {
  state.getByIdDonwload.buffer = action.payload.buffer ? action.payload.buffer:"";
  state.getByIdDonwload.result = action.payload.result ? action.payload.result:false;
}

function conexionGetByIdDonwload(state, action) {
  state.getByIdDonwload.connection= action.payload.connection;
}

function errorgGetByIdDonwload(state, action) {
  state.getByIdDonwload.error= action.payload.error ? action.payload.error:false;
  state.getByIdDonwload.message= action.payload.message ? action.payload.message:"";
}

function getByIdDonwloadReset(state, action) {
  state.getByIdDonwload.buffer=""
  state.getByIdDonwload.result=false;
  state.getByIdDonwload.connection= false;
  state.getByIdDonwload.error= false;
  state.getByIdDonwload.message= "";
}

/**
 * Conexión
 */
const documentsReducer = createSlice({
  name: 'documents',
  initialState: initState,
  reducers: {
    // GETBYID
    getById,
    conexionGetById,
    errorGetById,
    // CREATE
    create,
    conexionCreate,
    errorCreate,
    createReset,
    // GETBYIDDONWLOAD
    getByIdDonwload,
    conexionGetByIdDonwload,
    errorgGetByIdDonwload,
    getByIdDonwloadReset
  },
});

export const documentsActions = {
  ...documentsReducer.actions,
};

export default documentsReducer.reducer;
